import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://bereliable-474393705172.europe-west1.run.app/api';

// Set up axios defaults
axios.defaults.baseURL = API_URL;

// Add auth token to requests if available
const token = localStorage.getItem('adminToken');
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

// Response interceptor to handle token expiry
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear auth and redirect to login
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminAuth');
      delete axios.defaults.headers.common['Authorization'];
      
      // Only redirect if not already on login page
      if (window.location.pathname !== '/admin/login') {
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axios;


